import { render, staticRenderFns } from "./RowItem.vue?vue&type=template&id=a81d5eae&scoped=true"
import script from "./RowItem.vue?vue&type=script&lang=js"
export * from "./RowItem.vue?vue&type=script&lang=js"
import style0 from "./RowItem.vue?vue&type=style&index=0&id=a81d5eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81d5eae",
  null
  
)

export default component.exports